import { render, staticRenderFns } from "./ContactDetailsProperty.vue?vue&type=template&id=0d91fc0a&"
import script from "./ContactDetailsProperty.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports